import styled from "@emotion/styled";
import { ProgressBarProps } from "./progress-bar.props";
import { BASE_COLORS } from "../../emotion-theme";

const radiusPx = 12;

export const ProgressBarBorder = styled.div`
  margin: 0 8px;
  border-radius: ${radiusPx}px;
  border: solid 1px ${BASE_COLORS.navyBlue};
  height: 20px;
  overflow: hidden;
`;

export const ProgressBarProgress = styled.div`
  height: 100%;
  background-color: ${BASE_COLORS.paleBlue};
  width: ${(props: ProgressBarProps) => props.percent}%;
`;
